var toString = require('../lang/toString');
    /**
     * Checks if string ends with specified suffix.
     */
    function endsWith(str, suffix) {
        str = toString(str);
        suffix = toString(suffix);

        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    module.exports = endsWith;




//////////////////
// WEBPACK FOOTER
// ./~/mout/string/endsWith.js
// module id = 1663
// module chunks = 0 1 2